import { render } from "./ProgressSpinner.vue?vue&type=template&id=2e10e58e"
import script from "./ProgressSpinner.vue?vue&type=script&lang=js"
export * from "./ProgressSpinner.vue?vue&type=script&lang=js"

import "./ProgressSpinner.vue?vue&type=style&index=0&id=2e10e58e&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__